import { USER_SESSION_SERVICE_NAME } from "../../../services/user-session";
import { IMRBaseComponent } from "../../../modules/common/base";
import { LocationSchemaAssignPopupController } from "./location-schema-assign-popup.controller";

//#region Asset Imports

import * as TEMPLATE from "./location-schema-assign-popup.tpl.html";
import './location-schema-assign-popup.scss'

//#endregion

export class LocationSchemaAssignPopupComponent extends IMRBaseComponent {
  constructor() {
    super({
      controller: LocationSchemaAssignPopupController,
      services: [
        USER_SESSION_SERVICE_NAME,
      ],
      template: TEMPLATE,
    });
  }
}
